/* eslint-disable consistent-return */
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { RiAlertLine, RiAlertFill } from 'react-icons/ri';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import { checkRol } from '../../../../../security';
import { inspector } from '../../../../../security/constantsRols';
import { removeExpertReview } from '../../../../../services/workReport';
import useToast from '../../../../../hooks/useToast';
import LoaderContext from '../../../../../context/LoaderProvider';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './AlertWorkReportApproverButton.module.scss';

/**
 * @typedef Props
 * @property {(action: import('../../../../WeeklyReportTable/reducer/optimisticUIReducer').OptimisticUIActions) => void} handleChangedActions
 */

/** @param {Props} */
const AlertWorkReportApproverButton = ({
  dailyWorkReport,
  fetchData,
  handleChangedActions,
  selectedDate
}) => {
  const isInspector = checkRol(inspector);
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const { activeExpertReviewModal } = useWorkReportModals();

  const fetchDataWithDefaultParams = () => {
    fetchData();

    if (!isInspector) return handleChangedActions({ type: 'inspector.revision' });

    if (dailyWorkReport.tieneErrorSE) return handleChangedActions({ type: 'inspector.errorSE' });

    return handleChangedActions(
      dailyWorkReport?.requiereInspeccion
        ? { type: 'inspector.inspectorMustAct' }
        : { type: 'inspector.inspected' }
    );
  };

  const setColor = () => {
    if (dailyWorkReport?.revisionExperta) {
      return 'warning';
    }

    return 'dark';
  };

  const handleOnClick = async () => {
    if (!isInspector) {
      return activeExpertReviewModal(
        { ...dailyWorkReport, date: selectedDate },
        fetchDataWithDefaultParams
      );
    }

    try {
      setLoader(true);
      await removeExpertReview(dailyWorkReport.idParteDiario);
      fetchDataWithDefaultParams();
      setNewToast({ type: 'SUCCESS', message: 'Se ha desmarcado la revisión experta' });
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    } finally {
      setLoader(false);
    }
  };

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Pedido de revisión">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <Button
          className={styles['button-with-tooltip']}
          colorIcon={setColor()}
          icon={dailyWorkReport?.revisionExperta ? RiAlertFill : RiAlertLine}
          onClick={handleOnClick}
          type="button"
          variant="light"
          widthButton="30px"
        />
      </div>
    </ComponentWithTooltip>
  );
};

export default AlertWorkReportApproverButton;

AlertWorkReportApproverButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  selectedDate: PropTypes.string.isRequired,
  handleChangedActions: PropTypes.func,
  fetchData: PropTypes.func.isRequired
};

AlertWorkReportApproverButton.defaultProps = {
  handleChangedActions: () => {}
};
